import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { makeStyles } from '@mui/styles';
import tokens from '../../../styles/designTokens';
import { body2 } from '../../../styles/typography';
import { useEffect, useState } from 'react';

const useStyles = makeStyles(() => ({
  mainContainer: {
    width: '100%'
  },
  countBadge: {
    backgroundColor: tokens.product15,
    color: tokens.product90,
    fontSize: '0.75rem',
    fontWeight: 600,
    height: '1rem',
    padding: '0.125rem 0.375rem',
    borderRadius: '9rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
    minWidth: '1rem'
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '1.625rem',
    gap: '0.5rem'
  },
  navigationButtonsContainer: {
    width: '4.5rem',
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
  },
  navigationButton: {
    width: '2rem',
    height: '2rem',
    borderRadius: 4,
    borderWidth: 1,
    opacity: 1,
    paddingTop: 6,
    paddingRight: tokens.spacing[3],
    paddingBottom: 6,
    paddingLeft: tokens.spacing[3],
    border: `0.063rem solid ${tokens.neutral300}`,
  },
  title: {
    ...body2,
  },
  barContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    paddingBottom: '0.75rem',
  }
}));

export function CitationsBar({
  title = 'Citations',
  value,
  total,
  handleCitationChange,
}) {
  const classes = useStyles();

  // Store the current citation index in a local state
  const [currentCitationIndex, setCurrentCitationIndex] = useState(0);


  useEffect(() => {
    handleCitationChange(currentCitationIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCitationIndex]);

  return (
    <div className={classes.mainContainer}>
      <div className={classes.barContainer}>
        <div className={classes.headerContainer}>
          <Typography className={classes.title}>
            {title}
          </Typography>
          <div className={classes.countBadge}>
            {value}/{total}
          </div>
        </div>

        <div className={classes.navigationButtonsContainer}>
          <IconButton
            className={classes.navigationButton}
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              if (currentCitationIndex <= 0) {
                // Wrap to last citation
                setCurrentCitationIndex(total - 1);
              } else {
                setCurrentCitationIndex(currentCitationIndex - 1);
              }
            }}
            disabled={total <= 1}
            aria-label="Previous citation"
          >
            <KeyboardArrowUpRoundedIcon />
          </IconButton>
          <IconButton
            className={classes.navigationButton}
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              if (currentCitationIndex >= total - 1) {
                // Wrap to first citation
                setCurrentCitationIndex(0);
              } else {
                setCurrentCitationIndex(currentCitationIndex + 1);
              }
            }}
            disabled={total <= 1}
            aria-label="Next citation"
          >
            <KeyboardArrowDownRoundedIcon />
          </IconButton>
        </div>
      </div>
      <Divider />
    </div>
  );
}
